import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  inline-size: fit-content;
  padding-block: 0;
  padding-inline: 4px;

  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};

  background: rgba(44, 70, 146, 0.8);
`;
